import { render, staticRenderFns } from "./BbppAtencionDeClientesDocumentos.vue?vue&type=template&id=0c632a82"
import script from "./BbppAtencionDeClientesDocumentos.vue?vue&type=script&lang=js"
export * from "./BbppAtencionDeClientesDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports